import { FC } from "react"
import { createStyles, makeStyles } from "@material-ui/core"
import { colors } from "../../utils/theme"
import React from "react"

const useStyles = makeStyles((theme) =>
  createStyles({
    template: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      height: "100vh",
      backgroundColor: colors.primary.cloud,
      alignItems: "center",
      justifyContent: "center",
    },
  })
)

export const BaseTemplate: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const classes = useStyles()
  return <div className={classes.template}>{children}</div>
}
